// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2ik_S","left":"InfoRow_left__1b92B"};